import React, {FC, useEffect, useRef, useState} from 'react'
import styles from './styles.module.scss'

const rowHeight = 22

export const TextSpoiler: FC<{text: string}> = ({text}) => {
  const aboutMeRef = useRef<HTMLDivElement | null>(null)
  const [isAbout, setIsAbout] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  const resizeHandler = () => {
    aboutMeRef.current && setIsAbout(aboutMeRef.current.offsetHeight > rowHeight * 2)
  }

  useEffect(() => {
    resizeHandler()
    setIsOpen(false)
  }, [text])

  useEffect(() => {
    window.addEventListener('resize', resizeHandler)

    return () => window.removeEventListener('resize', resizeHandler)
  }, [aboutMeRef])

  return (
    <div className={styles.wrapper}>
      <div className={`${styles.text} ${!isOpen ? styles.ellipses : ''}`}>
        <span ref={aboutMeRef}>{text}</span>
      </div>
      {
        isAbout
          ? <div className={styles.about} onClick={() => setIsOpen(!isOpen)}>
            {!isOpen ? 'About' : 'Hide'}
          </div>
          : null
      }
    </div>
  )
}